import log from '@atlassian/jira-common-util-logging/src/log.tsx';
/**
 * Determines if a given date happened within the last N days
 * @param dateString - Date string in ISO format (e.g., "2025-08-07T22:31:49.733257Z")
 * @param days - Number of days to check back from current date
 * @param currentDate - Optional current date to compare against (defaults to new Date())
 * @returns boolean - true if the date is within the last N days, false otherwise
 */
export default function isWithinLastNDays(
	dateString: string,
	days: number,
	currentDate?: Date,
): boolean {
	// Parse the input date
	const inputDate = new Date(dateString);

	if (Number.isNaN(inputDate.getTime())) {
		log.safeErrorWithoutCustomerData(
			'jira-onboarding.utils.isWithinLastNDays',
			`Invalid date: ${dateString}`,
		);
		return false;
	}

	// Get current date (use provided date or create new one)
	const now = currentDate || new Date();

	// Calculate N days ago from now
	const nDaysAgo = new Date(now);
	nDaysAgo.setDate(now.getDate() - days);

	// Check if the input date is between N days ago and now
	return inputDate >= nDaysAgo && inputDate <= now;
}
